import { authRepository } from '@/infrastructure/repositories';
import { LoginDto, Admin, HttpError, ChangePasswordDto, ChangePasswordResponse } from '@/domain/entities';
import { getAuthToken } from '@/infrastructure/config/api.config';

export class AuthService {
  async login(credentials: LoginDto): Promise<Admin> {
    try {
      const response = await authRepository.login(credentials);
      return response.admin;
    } catch (error) {
      if (error instanceof HttpError) {
        throw error;
      }
      throw new Error('Login failed');
    }
  }

  logout(): void {
    authRepository.logout();
  }

  isAuthenticated(): boolean {
    return !!getAuthToken();
  }

  async changePassword(data: ChangePasswordDto): Promise<ChangePasswordResponse> {
    try {
      return await authRepository.changePassword(data);
    } catch (error) {
      if (error instanceof HttpError) {
        throw error;
      }
      throw new Error('Failed to change password');
    }
  }
}

export const authService = new AuthService();

